import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import NotificationsNone from '@material-ui/icons/NotificationsNone'
import Settings from '@material-ui/icons/Settings'
import Icon from '@mdi/react'
import { mdiLogoutVariant, mdiCart, mdiAccount } from '@mdi/js'

import Search from '../../basic/search'
import CustomIconButton from '../../basic/customIconButton'
import CustomDrawer from '../../basic/customDrawer'

import { api } from '../../../functions/api'
import { toJS } from 'mobx'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Tooltip from '@material-ui/core/Tooltip'

import moment from 'moment'

import { debounce } from 'lodash';

import HtmlTitle from '../../basic/htmlTitle'

import './index.scss'

import { inject, observer } from 'mobx-react'

@inject('internal')
@inject('translate')
@observer
export default class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            openLogout: false,
            list_data: []
        }
    }

    componentDidMount() {
        this.getUserData();
        if (
            toJS(this.props.internal.user) &&
            toJS(this.props.internal.user.data) &&
            toJS(this.props.internal.user.data.permissions)
        ) {
            this.setPermissions();
            this.timer = setInterval(() => this.getUserData(), 600000) // 10 minut
        }
    }

    dropDownMenuItems = []

    setPermissions() {
        this.dropDownMenuItems = []
        let permissions = toJS(this.props.internal.user.data.permissions)
        if (permissions.privileges && permissions.privileges.view) {
            this.dropDownMenuItems.push({
                title: this.props.translate.i18n.GLOBAL.HEADER.PRIVILEGES,
                url: 'privileges/admin'
            })
        }
        if (permissions.static_pages && permissions.static_pages.view) {
            this.dropDownMenuItems.push({
                title: this.props.translate.i18n.GLOBAL.HEADER.STATIC_PAGES,
                url: 'static_pages'
            })
        }
        if (permissions.lists_email_templates && permissions.lists_email_templates.view) {
            this.dropDownMenuItems.push({
                title: this.props.translate.i18n.GLOBAL.HEADER.TEMPLATES,
                url: 'templates'
            })
        }
        if (permissions.global_settings && permissions.global_settings.view) {
            this.dropDownMenuItems.push({
                title: this.props.translate.i18n.GLOBAL.HEADER.SETTINGS,
                url: 'settings/basic'
            })
        }

        if (permissions.lists_monitored_shops && permissions.lists_monitored_shops.view) {
            this.dropDownMenuItems.push(
              {
                  title: this.props.translate.i18n.GLOBAL.MENU.MONITORED_SHOPS,
                  url: 'monitored-shops',
              },
            )
        }

        if (permissions.products && permissions.products.update) {
            this.dropDownMenuItems.push(
              {
                  title: this.props.translate.i18n.MODULES.PRODUCT_SHOPS_MANAGEMENT.TITLE,
                  url: 'monitored-product-shops',
              },
            )
        }

        this.forceUpdate()
    }

    routes = [
        {
            title: this.props.translate.i18n.GLOBAL.MENU.DASHBOARD,
            link: '/'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.ADMINISTRATORS,
            link: '/administrators'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.CLIENTS,
            link: '/clients'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.PRODUCTS,
            link: '/products'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.ISSUE_CARDS,
            link: '/issue-cards'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.TO_STORAGE,
            link: '/to-storage'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.STORAGE,
            link: '/storage'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.VIGNETTES,
            link: '/vignettes'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.MONITORED_SHOPS,
            link: '/monitored-shops'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.CATEGORIES,
            link: '/categories'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.TAGS,
            link: '/tags'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.TRANSPORTS,
            link: '/transports'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.PAYMENTS,
            link: '/payments'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.SERVICE_PROTOCOLS,
            link: '/service-protocols'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.CONTACT,
            link: '/static/contact'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.TERMS_OF_USE,
            link: '/static/terms_of_use'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.PARAMETERS,
            link: '/parameters'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.MENU,
            link: '/menu'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.TOP_PRODUCTS,
            link: '/top-products'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.FIXED_SETS,
            link: '/fixed-sets'
        },
        {
            title: this.props.translate.i18n.MODULES.SHOPPING_CART.SHOPPING_CART,
            link: '/shoppingCart'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.DYNAMIC_SETS,
            link: '/dynamic-sets'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.CUSTOMERS,
            link: '/customers'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.CUSTOMERS_ORDERS,
            link: '/customers-orders'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.GIFTS,
            link: '/gifts'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.SHOPS,
            link: '/shops'
        },
        {
            title: this.props.translate.i18n.GLOBAL.MENU.LIST_CUSTOMER_ORDER_STATUSES,
            link: '/customer-order-statuses'
        }
    ]

    handleDrawerOpen = () => {
        this.setState({ open: !this.state.open }, () => {
            this.props.open(this.state.open)
        })
    }

    handleDrawerClose = () => {
        this.setState({ open: !this.state.open }, () => {
            this.props.open(this.state.open)
        })
    }

    handleLogout = () => {
        this.setState({ openLogout: true })
        //this.logout();
        //this.props.internal.logout();
    }

    logout = async () => {
        let load_data = await api({
            method: 'get',
            url: 'logout',
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success === true) {
            localStorage.clear()
            this.props.internal.setSnackbar(load_data.data.message, true)
            this.props.internal.logout()
            this.props.internal.pushRoute('/')
        }

    }

    setHeaderTitle = () => {
        let currentModule = '/' + toJS(this.props.internal.route.link).split('/')[1]
        for (let i = 0; i < this.routes.length; i++) {
            if (
                this.routes[i].link === toJS(this.props.internal.route.link) ||
                this.routes[i].link === currentModule
            ) {
                this.props.internal.setHeaderTitle(this.routes[i].title)
            }
        }
    }

    handleCloseLogoutDialog = () => {
        this.setState({ openLogout: false })
    }

    goToShoppingCart = () => {
        if (this.props.internal.numberOfItemsInShopingCart > 0) {
            this.props.internal.pushRoute('/shoppingCart')
        } else {
        }
    }

    showInfoAboutMe = () => {
        const role_id = toJS(this.props.internal.user.data.role.id)
        const id_logged_user = toJS(this.props.internal.user.data.id)

        if (role_id === 2 || role_id === 5) {
            this.props.internal.pushRoute(`/administrators/${id_logged_user}/edit/tab=0`)
        } else if (role_id > 2) {
            let cleintId = toJS(this.props.internal.user.data.client.id)
            this.props.internal.pushRoute(`/clients/${cleintId}/basic`)
        }
    }

    getUserData = async () => {
        let load_data = await api({
            method: 'get',
            url: 'user',
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success === true) {
            localStorage.setItem('user', JSON.stringify(load_data.data))
            this.props.internal.loginUser(load_data.data, true)
        }
    }

    notifications = []
    numOfNuotifications = 0

    getNotifications = () => {
        this.notifications = []

        this.numOfNuotifications = 0
        this.numOfNuotifications = this.props.internal.user.data.unread_notifications

        let notifications = toJS(this.props.internal.user.data.notifications)

        if (notifications.length) {
            // this.numOfNuotifications = notifications.length;
            let notificationsId = []
            for (let i = 0; i < notifications.length; i++) {
                notificationsId.push(notifications[i].id)
                //TODO: neviem ci bude fungovat na zivom serveri
                let url = notifications[i].data.uri
                let urlArr = url.split('.sk/')
                this.notifications.push({
                    title: notifications[i].data.message,
                    secondary: notifications[i].data.secondary || null,
                    order_status: notifications[i].data.order_status,
                    url: urlArr[1],
                    local: notifications[i].data.local,
                    action: 'notifications',
                    notification_id: toJS(notifications[i].id),
                    readed: notifications[i].is_read,
                    //created_at: dateformat(notifications[i].created_at, "dd.mm.yyyy HH:MM")
                    created_at: moment(notifications[i].created_at).format('DD.MM.YYYY')
                })
            }
            this.props.internal.setNotifications(notificationsId)
        } else {
            this.notifications.push({
                title: this.props.translate.i18n.GLOBAL.HEADER.NO_NOTIFICATIONS_TEXT,
                action: null,
                disabled: true,
                created_at: ''

            })
        }
    }
    list_data = []
    handleSearch = debounce(async searchTerm => {
        if (searchTerm) {
            let load_data = await api({
                method: 'get',
                url: 'search',
                authorization: this.props.internal.user.access_token,
                params: {
                    searchterm: searchTerm
                }
            })

            if (load_data.success === true) {
                // this.list_data = load_data.data.data
                // let tmpData = load_data.data.data
                // let tmpList = []
                // for (let data in tmpData) {
                //     for (let data2 in tmpData[data]) {
                //         tmpData[data][data2].type = data // pridavam typ (administrators, products, clients) najdenej polozky
                //         tmpList.push(tmpData[data][data2])
                //     }
                // }
                // this.setState({ list_data: tmpList })
                this.setState({ list_data: load_data.data.data })
            }
        } else {
            this.setState({ list_data: [] })
        }
    }, 750)

    render() {
        this.setHeaderTitle()
        let link = require('mobx').toJS(this.props.internal.route.link)

        let expanded
        if (link.includes('/clients') && /\d/.test(link) && !link.includes('/clients?')) {
            expanded = true
        } else if (link.includes('/issue-cards/') && /\d/.test(link)) {
            expanded = true
        } else {
            expanded = !! link.includes('edit/')
        }

        let shopping_cart = !! link.includes('/shoppingCart')

        let privileges = !! link.includes('/privileges')

        let settings = !! link.includes('settings')

        let templates = false
        if (
            link.includes('/templates/new') ||
            (link.includes('/templates') && /\d/.test(link)) ||
            link.includes('/customer-order-statuses/new') ||
            (link.includes('/customer-order-statuses/') &&
                /\d/.test(link) &&
                link.includes('/edit'))
        ) {
            templates = true
        }

        let static_pages = false
        if (
            link.includes('/static_pages/new') ||
            (link.includes('/static_pages') && /\d/.test(link) && link.includes('/edit'))
        ) {
            static_pages = true
        }

        let product_detail = false
        if (link.includes('/products') && /\d/.test(link) && link.includes('/detail')) {
            product_detail = true
        }

        let product_edit = false
        if (link.includes('/products') && /\d/.test(link) && link.includes('/edit')) {
            product_edit = true
        }

        let menu_article = false
        if (link.includes('/menu/article')) {
            menu_article = true
        }

        let shops = false
        if (link.includes('/shops') && /\d/.test(link)) {
            shops = true
        }

        let role = {}
        if (
            toJS(this.props.internal.user) &&
            toJS(this.props.internal.user.data) &&
            toJS(this.props.internal.user.data.role)
        ) {
            role = {
                name: toJS(this.props.internal.user.data.role.name),
                id: toJS(this.props.internal.user.data.role.id)
            }

            this.getNotifications()
        }
        return (
            <div
                className={`header ${expanded ? 'expanded' : ''}${shopping_cart ? 'shopping' : ''}${
                    privileges ? ' privileges' : ''
                }${templates ? ' templates' : ''}${static_pages ? ' static_pages' : ''}${
                    settings ? ' settings' : ''
                }${product_detail ? ' header-product-detail' : ''}${
                    product_edit ? ' header-product-edit' : ''
                }${menu_article ? ' menuArticle' : ''}${shops ? ' shops' : ''}`}
            >
                <HtmlTitle />
                {/* <div className={`header`} > */}
                <Dialog
                    open={this.state.openLogout}
                    onClose={this.handleCloseLogoutDialog}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                >
                    <DialogTitle id='alert-dialog-title'>
                        {this.props.translate.i18n.GLOBAL.HEADER.LOGOUT_TITLE}
                    </DialogTitle>
                    <DialogContent className={'logout-dialog'}>
                        <DialogContentText id='alert-dialog-description'>
                            {this.props.translate.i18n.GLOBAL.HEADER.LOGOUT_CONTENT}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseLogoutDialog} className={'text-gray'}>
                            {this.props.translate.i18n.GLOBAL.BUTTONS.NO}
                        </Button>
                        <Button onClick={this.logout} className={'btn-white-bg'} autoFocus>
                            {this.props.translate.i18n.GLOBAL.BUTTONS.YES}
                        </Button>
                    </DialogActions>
                </Dialog>
                <CustomDrawer open={this.state.open} onClose={this.handleDrawerClose} />
                <AppBar position='static'>
                    <Toolbar>
                        <div className={'left-part'}>
                            <IconButton
                                aria-label='Menu'
                                className={'burger-menu-btn'}
                                onClick={this.handleDrawerOpen}
                            >
                                <MenuIcon />
                            </IconButton>
                            <span className={'header-title'}>
                                {this.props.internal.headerTitle}
                            </span>
                        </div>

                        <Search
                            placeholder={this.props.translate.i18n.GLOBAL.HEADER.SEARCH}
                            onChange={this.handleSearch}
                            data={this.state.list_data}
                        />

                        <div className={'info-user'}>
                            {/* {(this.props.internal.shoppingCart).length > 0 ?  */}

                            {/* {toJS(this.props.internal.user) && toJS(this.props.internal.user.data) && toJS(this.props.internal.user.data.role) && toJS(this.props.internal.user.data.role.id) && toJS(this.props.internal.user.data.role.id) !== 2 ? */}
                            {/* {role.id !== 2 ? */}
                            {toJS(this.props.internal.user) &&
                            toJS(this.props.internal.user.data) &&
                            toJS(this.props.internal.user.data.permissions) &&
                            toJS(this.props.internal.user.data.permissions.shopping_cart) &&
                            toJS(this.props.internal.user.data.permissions.shopping_cart.use) ? (
                                <CustomIconButton
                                    label='ShoppingCart'
                                    showBadge={
                                        this.props.internal.numberOfItemsInShopingCart > 0
                                    }
                                    // numberOfNotifications={(this.props.internal.shoppingCart).length}
                                    numberOfNotifications={
                                        this.props.internal.numberOfItemsInShopingCart
                                    }
                                >
                                    <Tooltip
                                        title={
                                            this.props.translate.i18n.MODULES.SHOPPING_CART
                                                .EMPTY_CART
                                        }
                                        disableHoverListener={
                                            this.props.internal.numberOfItemsInShopingCart !== 0
                                        }
                                    >
                                        <Icon
                                            path={mdiCart}
                                            size={1}
                                            onClick={this.goToShoppingCart}
                                        />
                                    </Tooltip>
                                </CustomIconButton>
                            ) : null}

                            {this.dropDownMenuItems.length ? (
                                <CustomIconButton
                                    label='Settings'
                                    dropdownMenu
                                    items={this.dropDownMenuItems}
                                >
                                    <Settings />
                                </CustomIconButton>
                            ) : null}
                            <CustomIconButton
                                label='NotificationsNone'
                                showBadge={this.numOfNuotifications > 0}
                                numberOfNotifications={this.numOfNuotifications}
                                dropdownMenu
                                items={this.notifications}
                                notifications
                            >
                                <NotificationsNone />
                            </CustomIconButton>

                            <CustomIconButton>
                                <Icon
                                    path={mdiLogoutVariant}
                                    size={1}
                                    onClick={this.handleLogout}
                                />
                            </CustomIconButton>
                            <div className={'icon-user'}>
                                <CustomIconButton>
                                    <Icon
                                        path={mdiAccount}
                                        size={1}
                                        onClick={this.showInfoAboutMe}
                                    />
                                </CustomIconButton>
                            </div>

                            {/* <Icon path={mdiLogoutVariant} size={1}  /> */}
                            <div className={'profile-info'} onClick={this.showInfoAboutMe}>
                                <b>
                                    {this.props.internal.user.data.first_name}{' '}
                                    {this.props.internal.user.data.last_name}
                                </b>
                                <span>
                                    {role.id === 4 || role.id === 3
                                        ? toJS(this.props.internal.user.data.client.name)
                                        : this.props.translate.i18n.GLOBAL.ROLES[role.id]}
                                </span>
                            </div>

                            {/* <button onClick={this.handleLogout}> logout </button> */}
                        </div>
                    </Toolbar>
                </AppBar>
                {/* <SubHeader/> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/global/header/index.js